import * as React from 'react'

import { CartButton as CartButtonV2 } from '@grandvisionhq/carts-v2'
import { CartButton } from '@grandvisionhq/common'
import { MenuItemType } from '@grandvisionhq/layout'
import { CmsLayoutSettings, withCmsLayout } from '@grandvisionhq/next'

import { isCartV2Enabled } from '../util/feature-toggle'

export const layoutSettings: CmsLayoutSettings = {
  renderCartButton: (item: MenuItemType) => {
    const props = {
      key: item.label,
      label: item.label,
      href: item.link?.href,
      className: 'header-menu__icon',
    }
    return isCartV2Enabled() ? <CartButtonV2 {...props} /> : <CartButton {...props} />
  },
}

export default withCmsLayout(layoutSettings)
